<div>
    <div class="section">
        <h2>{{text('force.max')}}</h2>
        <div class="row">
            <div class="col-4 text-center">{{text('deficit')}}: {{iDeficitFormatted}}</div>
            <div class="col-4 text-center">{{text('deficit')}}: {{yDeficitFormatted}}</div>
            <div class="col-4 text-center">{{text('deficit')}}: {{tDeficitFormatted}}</div>
        </div>
        <div class="d-inline-block full-width">
            <app-body-side-bar-chart [dataTitles]="maxPerPositionTitles"
                                     [data]="maxPerPositionData"
                                     [valueFractionDigits]="1">
            </app-body-side-bar-chart>
        </div>
    </div>
    <div class="section section-repetitions">
        <h2>{{text('rep.analysis')}}</h2>
        <div class="repetition d-flex flex-row mb-4">
            <div class="repetition-title d-flex align-items-center">{{maxPerPositionTitles[0]}}</div>
            <app-meter-endurance-statistics-row class="flex-grow-1"
                                                [repetitionResults]="iRepsViewmodel"
                                                [displayRepetitionOrdinal]="false"></app-meter-endurance-statistics-row>
        </div>
        <div class="repetition d-flex flex-row">
            <div class="repetition-title d-flex align-items-center">{{maxPerPositionTitles[1]}}</div>
            <app-meter-endurance-statistics-row class="flex-grow-1"
                                                [repetitionResults]="yRepsViewmodel"
                                                [displayRepetitionOrdinal]="false"></app-meter-endurance-statistics-row>
        </div>
        <div class="repetition d-flex flex-row">
            <div class="repetition-title d-flex align-items-center">{{maxPerPositionTitles[2]}}</div>
            <app-meter-endurance-statistics-row class="flex-grow-1"
                                                [repetitionResults]="tRepsViewmodel"
                                                [displayRepetitionOrdinal]="false"></app-meter-endurance-statistics-row>
        </div>
    </div>

</div>
